module.exports = __webpack_public_path__ + "images/6c0f662965b0d5e53601a0a9cba2b462.svg";